export const environment = {
    production: false,
    apiEndpoint: 'https://eduscript-ai-studio-backend-production.up.railway.app/api/',
    orgName: 'uat',
};
